import { FC } from 'react';
import { ExternalLink } from '../link';
import { INavLink } from '../../models';
import { PortalCard } from './portal-card';

interface IExternalLinkPortalCard {
  link: INavLink;
}

export const ExternalLinkPortalCard: FC<IExternalLinkPortalCard> = ({ link }) => {
  return (
    <ExternalLink to={link.legacyUrl} target="_blank">
      <PortalCard link={link} />
    </ExternalLink>
  );
};
